import styled from 'styled-components';

import { colors, typography } from '../../../../styles/tokens';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 520px), 1fr));
  gap: 20px;
`;

export const Card = styled.div`
  border-radius: 28px;
  border: 1px solid ${colors.border};
  background: ${colors.surface};
  padding: 30px;
  transition: border-color 0.2s;

  &:hover {
    border-color: ${colors.borderHighlight};
  }
`;

export const Number = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 999px;
  background: ${colors.surfaceAccent};
  color: ${colors.primary};

  display: grid;
  place-items: center;

  font-family: ${typography.displayFontFamily};
  font-weight: 700;
  font-size: 15px;
`;

export const Title = styled.h3`
  font-family: ${typography.displayFontFamily};
  font-weight: 600;
  font-size: 20px;
  margin: 18px 0 8px;
  color: ${colors.textPrimary};
`;

export const Description = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 1.65;
  color: ${colors.textMuted};
`;
